import { RootState } from '../../../app/store'
import { ReduxCrmKey } from '../../crm/types'

export const getCrmKey = (state: RootState) =>
  state.user?.data?.userSettings?.connectedCRM?.name?.toLowerCase?.() as ReduxCrmKey | undefined
